export const WithBulkUpdateRepository = ({
  patch, scope, edmCampaign, updateLevel, budgetId,
}) => {
  const {
    values: {
      cid, aid, adGroupId, campaignId, budgetId: budgetIdFromScope,
    },
  } = scope;

  const currentEntity = edmCampaign
    .Customers
    .$withKey(cid)
    .Accounts
    .$withKey(aid);

  if (updateLevel === 'Budget') {
    const updatedBudgetId = budgetId || budgetIdFromScope;

    return currentEntity.Budgets
      .$withKey(updatedBudgetId)
      .bulkUpdate({
        Id: updatedBudgetId,
        ...patch,
      });
  } else if (updateLevel === 'Campaign') {
    return currentEntity.Campaigns
      .$withKey(campaignId)
      .bulkUpdate({
        Id: campaignId,
        ...patch,
      });
  }

  return currentEntity.AdGroups
    .$withKey(adGroupId)
    .bulkUpdate({
      Id: adGroupId,
      Campaign: { Id: campaignId },
      ...patch,
    });
};
